
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class SpinnerState extends BaseYcState {
  readonly loading: boolean = false;
  readonly loadingMessage: string;
}
